import React, {useState} from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
    Theme,
    Typography
} from "@mui/material";
import Strings from "../../assets/strings"
import {formatDate, formatPeso} from "../../helpers";
import {IAdminCuadreDetalle} from "../../redux/types/IAdminCuadre";
import {ReactComponent as EmptySvg} from "../../assets/img/empty.svg";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme:Theme) => ({

    emptyCont:{
        paddingTop:"7%",
        textAlign:"center",
        opacity: .7,
        "&:hover":{
            opacity: 1,
        },
        "& p":{
            marginTop:0,
            color: theme.palette.text.secondary,
        }
    }
}));


export default function  CuadrePagos({bancosPagos}:{bancosPagos?:IAdminCuadreDetalle[]}) {
    const classes = useStyles();
    let [showIndex, setShowIndex] = useState<number | undefined>(0)
    return <>
        {bancosPagos?.length ? ( <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{width:150}}>{Strings.fecha}</TableCell>
                            <TableCell>Cliente</TableCell>
                            <TableCell align={"right"}>Monto</TableCell>
                            <TableCell align={"center"}>Cuotas</TableCell>
                            <TableCell>Referencia</TableCell>
                            <TableCell>Concepto</TableCell>
                            <TableCell>{Strings.comentario}</TableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {bancosPagos?.map((banco, index)=><React.Fragment key={banco.bancoId}>
                            <TableRow onClick={()=>setShowIndex(showIndex === index ? undefined : index)}>
                                <TableCell> <Typography fontWeight={"bold"} color={"secondary"}>{banco.banco}</Typography></TableCell>
                                <TableCell/>
                                <TableCell align={"right"} ><Typography fontWeight={"bold"} color={"secondary"}>{formatPeso(banco.monto)}</Typography></TableCell>
                                <TableCell colSpan={4} />
                            </TableRow>
                            { showIndex === index && banco?.pagos?.map(n =>
                                <TableRow key={n.id}>
                                    <TableCell>{formatDate(n.fechaCreacion)} {formatDate(n.fechaCreacion,"h:mm a")}</TableCell>
                                    <TableCell>{n.cliente}</TableCell>
                                    <TableCell align={"right"}>{formatPeso(n.monto)}</TableCell>
                                    <TableCell align={"center"}>{n.cuotas}</TableCell>
                                    <TableCell>{n.referencia}</TableCell>
                                    <TableCell>{n.concepto}</TableCell>
                                    <TableCell>{n.comentario}</TableCell>

                                </TableRow>
                            )}

                        </React.Fragment>)}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell> <Typography fontWeight={"bold"}>Total</Typography></TableCell>
                            <TableCell/>
                            <TableCell align={"right"}>
                                <Typography fontWeight={"bold"}>
                                    {formatPeso(bancosPagos?.reduce((a, b)=> a + (b.monto ?? 0), 0))}
                                </Typography>
                            </TableCell>
                            <TableCell colSpan={4} />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </>):(
            <div className={classes.emptyCont}>
                <EmptySvg width={140} height={140}/>
                <p>{Strings.aunNoTienes} {Strings.registros}!</p>
            </div>
        )}
    </>;


}